<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Listado de descuentos vinculados"
      tabla-vista="desvin"
      icono="mdi-clipboard-search-outline"
      busqueda-rapida
      titulo-crud="x"

      :variables="misVariables"
      :filtro-registros="filtroRegistros"
      :key="filtroRegistros"      
     
    >

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },

  data: () => ({
    misVariables: null,
  }), 

  computed: {
    filtroRegistros () {
      console.log('filtroRegistros');
      let filtro = "1=1";
    
      /* se aplica un filtro para los operadores de la instalacion 
         a la que pertenece el usuario logado. Si se trata de un Administrador Equinsa 
         no hay filtrado.
        
         OJO CAGADA. En la tabla desvin, id_ins se refiere al codigo de instalacion SAGA, 
         no al id de la instalacion de la tabla de instalaciones de la web.
      */      
      if (null != this.$store.state.operador.instalacion.codins)   
        filtro += " AND id_ins = " + this.$store.state.operador.instalacion.codins; 

      return filtro;
    }, // fin filtroRegistros
  }, // fin computed

  mounted () {
      if (null != this.$store.state.operador.instalacion.id_ins)  { 

        console.log(this.$store.state.operador);
        this.misVariables = {
          "id_empinq": {
            "dominio_valores_sql": 
              "SELECT id_empinq AS v, nom AS d FROM empinq WHERE id_ins=" + 
              this.$store.state.operador.instalacion.id_ins + 
              " UNION SELECT NULL AS v, '(Ninguna)' AS d"
          },

          "id_rolope": {
            "dominio_valores_sql": 
              "SELECT id_rolope AS v, des AS d FROM c_rolope WHERE id_rolope <=" + 
              this.$store.state.operador.idRol
          },

        }  
      }
  } // fin mounted
};
</script>

<style>
</style>